import { useFormField } from '@calendly/form';
import { getTimezoneName } from '@calendly/timezone-tools';
import { IconWorld } from '@calendly/ui/components/glyphs/IconWorld';
import { BodyText } from '@calendly/ui/components/typography';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import { colorIconSecondary } from '@calendly/ui/theme';
import { TimezoneDropdown as BareTimezoneDropdown } from 'components/event_type_edit';
const timezoneRowCss = "tt6xacv";

/* Figma timezone trigger is muted gray, not action contrast / semibold */
const timezoneTriggerCss = "t1ar9p5";
export const V4TimezoneDropdown = ({
  formPath,
  readOnly
}) => {
  const [{
    value: timezone
  }, _, {
    setValue
  }] = useFormField({
    name: `${formPath}.timezone`
  });
  const [___, __, {
    setValue: setUsingCustomHours
  }] = useFormField({
    name: `${formPath}.usingCustomHours`
  });
  const [____, _____, {
    setValue: setUsingSecondarySchedule
  }] = useFormField({
    name: `${formPath}.usingSecondarySchedule`
  });
  const onChange = value => {
    setValue(value);
    setUsingCustomHours(true);
    setUsingSecondarySchedule(false);
  };
  if (readOnly) {
    return <div className={timezoneRowCss}>
        <UiIcon color={colorIconSecondary} icon={IconWorld} size="small" />
        <BodyText color="muted" size="small">{getTimezoneName(timezone)}</BodyText>
      </div>;
  }
  return <div className={timezoneRowCss}>
      <UiIcon color={colorIconSecondary} icon={IconWorld} size="small" />
      <BareTimezoneDropdown className={timezoneTriggerCss} timezone={timezone} onSelectTimezone={onChange} expandLeft shiftLeft15 noIcon />
    </div>;
};

require("./v4_timezone_dropdown.wyw-in-js.css!=!../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./v4_timezone_dropdown.js");